/*import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AppProvider } from "./Context/productcontext";
import { FilterContextProvider } from "./Context/filtercontext";
import { CartProvider } from "./Context/UseCartContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<AppProvider>
    <FilterContextProvider>
      <CartProvider>
        <App/>
      </CartProvider>
      
      
      
    </FilterContextProvider>
  </AppProvider>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();*/
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { AppProvider } from "./Context/productcontext";
import { FilterContextProvider } from "./Context/filtercontext";
import { CartProvider } from "./Context/UseCartContext";
import { Auth0Provider } from "@auth0/auth0-react";

//const root = ReactDOM.createRoot(document.getElementById("root"));
const root = ReactDOM.createRoot(document.getElementById("root"));

const domain = "dev-rihbpfowwzeoga6o.us.auth0.com";
const clientId = "Ql9hrK3uBQlbmICAsi59tnCRFHfFeSVj";

root.render(
  <Auth0Provider
    domain={domain}
    clientId={clientId}
    redirectUri={window.location.origin}>
    <AppProvider>
      <FilterContextProvider>
        <CartProvider>
          <App />
        </CartProvider>
      </FilterContextProvider>
    </AppProvider>
  </Auth0Provider>
);



// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
